import { CARDINALS } from './cardinals';
import { ORDINALS } from './ordinals';

// The first two digits could be "Two Thousand" or "Twenty", so leaving it freeform.
export function getTwoDigitsOrdinalFromYear(year: number): string {
  if (year <= 2000 || year > 2099) return '';
  return ORDINALS[year - 2000] ?? '';
}

// Example output: Four O'Clock in the Afternoon
export function getOclock(date: Date): string {
  const minutes = date.getMinutes();
  const minutePart = (() => {
    if (minutes === 0) return "O'Clock";
    if (minutes < 10) return `Oh ${CARDINALS[minutes]}`;
    return CARDINALS[minutes];
  })();

  return `${CARDINALS[date.getHours() % 12] || CARDINALS[12]} ${minutePart}`;
}

export function getTimeOfDay(date: Date): string {
  const hours = date.getHours();
  if (hours === 0) return 'Midnight';
  if (hours === 12) return 'Noon';
  if (hours >= 0 && hours < 12) return 'in the Morning';
  if (hours >= 12 && hours < 18) return 'in the Afternoon';
  if (hours >= 18 && hours < 21) return 'in the Evening';
  return 'at Night';
}

// Not an Ordinal, but very related to everything else here.
export function getAmOrPm(date: Date): 'am' | 'pm' {
  const hours = date.getHours();
  return hours < 12 ? 'am' : 'pm';
}
